import api from 'services/api';

export async function getTemplates({ organizationId }: { organizationId: string }) {
  const response = await api.get(
    `api/dashboard/organizations/${organizationId}/templates`,
  );
  return response;
}
